import { useStickyBottom } from '@hooks/use-sticky-bottom.hook';
import { cn } from '@lib/utils';
import { FC, ReactNode } from 'react';

type StickyColumnProps = {
  children: ReactNode;
  className?: string;
  isSticky?: boolean;
};

/**
 * A column that implements sticky behavior where shorter columns stick
 * when their bottom reaches the viewport bottom.
 *
 * - All columns scroll normally with the page
 * - When a column's bottom reaches the viewport bottom, it sticks there
 * - Taller columns continue scrolling normally
 */
export const StickyColumn: FC<StickyColumnProps> = (props) => {
  const { children, className, isSticky = true } = props;
  const { ref, style } = useStickyBottom();

  return (
    <div
      className={cn('flex flex-col gap-4', className)}
      ref={isSticky ? ref : undefined}
      style={isSticky ? style : undefined}
    >
      {children}
    </div>
  );
};
